import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./TransactionHistorySection')));

const TransactionHistoryRoutes = [
	{ path: '/dashboard/transactionhistory', element: <Analytics />, auth: authRoles.admin },
];

export default TransactionHistoryRoutes;
